export const DEFAULT_VALUES = {
  name: '',
  gender: '',
  weight: '',
  castrated: false,
  birth: '',
  specie: '',
  breed: '',
  temperament: ''
}
